import { Label, useDeviceSize } from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import SimpleResultsLottieData from '../../assets/json/SimplifiedResults.json';
import { useVariables } from '../../hooks';
import { RoutesName, PLATFORM_SUBDIRECTORY } from '../../states';
import { newOperationIdState } from '../../states/atoms';
import { CardResultsHeaderTitle, CardResultsSimple } from '../cards';
import { ResultsHeader } from './ResultHeader';
import { ResultsButton, ResultsWrapper, SimpleResultsLottie } from './Styles';

export const SimpleResults = () => {
  const { t } = useTranslation();
  const { isMobile } = useDeviceSize();
  const navigate = useNavigate();
  const { platformUrl } = useVariables();
  const operationId = useRecoilValue(newOperationIdState);

  const platformRedirectUrl = `${platformUrl}${PLATFORM_SUBDIRECTORY}/${operationId}`;

  const handleVisitPlatform = () => {
    window.open(platformRedirectUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <ResultsWrapper flexDirection="column" rowGap="1.6">
      <ResultsHeader />

      <CardResultsSimple
        flexDirection="column"
        alignItems="center"
        rowGap="0.8"
      >
        {isMobile && (
          <CardResultsHeaderTitle textAlign="left">
            {t('ADVANCED DETAILS')}
          </CardResultsHeaderTitle>
        )}
        {/* TODO: CHANGE LOTTIE JSON */}
        <SimpleResultsLottie
          loop={true}
          animation={SimpleResultsLottieData}
          preserveAspectRatio="xMidYMid meet"
          idLottie="simplified_screen_image"
          idTest="simplified_screen_image"
        />
        {/* TODO: CHANGE LOTTIE JSON */}
        <Label
          fontSize={isMobile ? '16' : '21'}
          semibold
          textAlign="center"
          id="simplified_screen_text"
          testId="simplified_screen_text"
        >
          {t('Consult the details of the Onboarding in our platform')}
        </Label>

        <Label
          fontSize="14"
          textAlign="center"
          id="simplified_screen_descripcion"
          testId="simplified_screen_descripcion"
        >
          {t('Use the same login as in Onboarding.')}
        </Label>
      </CardResultsSimple>

      <ResultsButton
        size="L"
        onClick={() => {
          navigate(RoutesName.home);
        }}
        variant="outline"
        testId="results_finish_button"
      >
        {t('Finish')}
      </ResultsButton>
      <ResultsButton
        size="L"
        onClick={handleVisitPlatform}
        variant="filled"
        testId="simplified_screen_go_to_platform_button"
      >
        {t('Go to platform')}
      </ResultsButton>
    </ResultsWrapper>
  );
};
